// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1mCz0","range":"MonthRangeSwitch_range__2oA3w","disabled":"MonthRangeSwitch_disabled__2a9sY"};